<h3>Select appropriate customer experience</h3>
@if (journeysSelected.length > 100) {
  <p class="error-msg">* You currently have {{journeysSelected.length}} Experiences Selected.  We recommend keeping it below 100.</p>
}
<div class="btn-container">
  @if (journeysSelected && journeysSelected.length > 0) {
    @for (journey of journeysSelected; track journey; let i = $index) {
      <app-journey-icon
        [clientId]="client.id" [journeyId]="journey" [backgroundColor]="generateColor(i)"
      [isPreview]="false"    (removeJourney)="journeyToRemove = $event"></app-journey-icon>
    }
  }
  <app-select-journey-button></app-select-journey-button>
</div>

@if (journeyToRemove) {
  <app-remove-journey-modal (cancelRemove)="journeyToRemove = undefined"
  (affirmRemove)="removeJourney(journeyToRemove)"></app-remove-journey-modal>
}
